import { render, staticRenderFns } from "./BadgeListGroup.vue?vue&type=template&id=4d285f25"
import script from "./BadgeListGroup.vue?vue&type=script&lang=js"
export * from "./BadgeListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports